import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CreditCard, MessageSquare, Heart, MapPin } from "lucide-react";
import { publicApi } from "../lib/api";
import { HeroSlider } from "../components/site/HeroSlider";
import { AnnouncementSidebar } from "../components/site/AnnouncementSidebar";
import { useResident } from "../context/ResidentAuth";

const QUICK = [
  { to: "/odemeler", icon: CreditCard, title: "Aidat & Ödemeler", text: "Borcunuzu görün, kartla ödeyin", id: "payments" },
  { to: "/dilek-sikayet", icon: MessageSquare, title: "Dilek & Şikayet", text: "Yönetime doğrudan yazın", id: "feedback" },
  { to: "/tebrik-taziye", icon: Heart, title: "Tebrik & Taziye", text: "Komşularımızın haberleri", id: "community" },
  { to: "/iletisim", icon: MapPin, title: "İletişim", text: "Adres ve yol tarifi", id: "contact" },
];

export default function HomePage() {
  const [data, setData] = useState(null);
  const { resident } = useResident();

  useEffect(() => {
    publicApi.get("/public/home").then((r) => setData(r.data)).catch(() => setData({ slides: [], announcements: [], has_more: false, settings: {} }));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-10">
      <div className="grid lg:grid-cols-12 gap-6">
        <div className="lg:col-span-8 fade-up">
          {data ? <HeroSlider slides={data.slides} settings={data.settings} /> : <div className="h-[52vh] lg:h-[600px] rounded-[2rem] bg-slate-200 animate-pulse" />}
        </div>
        <div className="lg:col-span-4 fade-up" style={{ animationDelay: "120ms" }}>
          {data && <AnnouncementSidebar items={data.announcements} hasMore={data.has_more} />}
        </div>
      </div>

      <section className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {QUICK.map((q, i) => (
          <Link key={q.id} to={resident || !["payments", "feedback"].includes(q.id) ? q.to : "/giris"} data-testid={`quick-${q.id}`}
            className="group fade-up bg-white rounded-3xl border border-black/5 p-6 hover:-translate-y-1 hover:shadow-[0_8px_32px_rgba(0,0,0,0.08)] transition-transform duration-200"
            style={{ animationDelay: `${200 + i * 70}ms` }}>
            <span className="w-11 h-11 rounded-2xl bg-[#D8F3DC] text-[#1B4332] flex items-center justify-center group-hover:bg-[#1B4332] group-hover:text-white transition-colors">
              <q.icon size={20} />
            </span>
            <p className="mt-5 font-display text-lg font-bold text-slate-800">{q.title}</p>
            <p className="text-sm text-slate-500 mt-1">{q.text}</p>
          </Link>
        ))}
      </section>
    </div>
  );
}
